import React, { Component } from 'react';
import Animated from 'animated/lib/targets/react-dom';
import noisewhite from './assets/noise-white.svg';
import './App.css';
import './Anim.css';
import { CSSTransition, TransitionGroup } from "react-transition-group";
import firebase from './firebase'

import MainScreen from './components/MainScreen';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import Team from './components/Team';
import ContactUs from './components/ContactUs';

import LeftCircle from './circle-components/LeftCircle';
import RightCircle from './circle-components/RightCircle';
import BottomCircle from './circle-components/BottomCircle';

const SCREEN_HOME = 0;
const SCREEN_PORTFOLIO = 1;
const SCREEN_SERVICES = 2;
const SCREEN_TEAM = 3;

const HIDE_LEFT = 10;
const HIDE_RIGHT = 11;
const HIDE_UP = 12;

const timeout = 1000; // for animations

class MainWebsite extends Component {

    componentDidMount() {
        // setup window size listener (for switching mobile to desktop)
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        const infoRef = firebase.database().ref('company-info');

        infoRef.once('value').then((snapshot) => {
            let companyInfo = snapshot.val();

            this.setState({
                companyName: companyInfo.name,
                sloganText: companyInfo.slogan
            });

            this.setLoaded();
        });
    }

    resize() {
        this.setState({
            isMobile: window.innerWidth <= 700
        })
    }

    // ANIMATION FUNCTIONS

    // NOISE
    moveNoiseRight = () => {
        Animated.timing(this.state.noiseX, { toValue: 125, duration: timeout }).start();
        Animated.timing(this.state.noiseY, { toValue: -50, duration: timeout }).start();
    }

    moveNoiseLeft = () => {
        Animated.timing(this.state.noiseX, { toValue: -125, duration: timeout }).start();
        Animated.timing(this.state.noiseY, { toValue: 50, duration: timeout }).start();
    }

    moveNoiseDownward = () => {
        Animated.timing(this.state.noiseX, { toValue: 25, duration: timeout }).start();
        Animated.timing(this.state.noiseY, { toValue: 200, duration: timeout }).start();
    }

    moveNoiseBackward = () => {
        Animated.timing(this.state.noiseX, { toValue: 0, duration: timeout }).start();
        Animated.timing(this.state.noiseY, { toValue: 0, duration: timeout }).start();
    }

    // CIRCLE
    moveCirclesLeft = () => {
        this.setState({
            leftCircleFocus: true,
            rightCircleHideDirection: HIDE_RIGHT,
            bottomCircleHideDirection: HIDE_RIGHT
        })
    }

    moveCirclesRight = () => {
        this.setState({
            rightCircleFocus: true,
            leftCircleHideDirection: HIDE_LEFT,
            bottomCircleHideDirection: HIDE_LEFT
        })
    }

    moveCirclesUp = () => {
        this.setState({
            bottomCircleFocus: true,
            leftCircleHideDirection: HIDE_UP,
            rightCircleHideDirection: HIDE_UP
        })
    }

    moveCirclesToOrigin = () => {
        this.setState({
            leftCircleFocus: false,
            rightCircleFocus: false,
            bottomCircleFocus: false,
            rightCircleHideDirection: '',
            leftCircleHideDirection: '',
            bottomCircleHideDirection: ''

        })
    }

    // for portfolio page
    moveRightCircleMoreToLeft = () => {
        this.setState({
            contactUsHidden: true,
            rightCircleHideDirection: HIDE_LEFT
        })
    }

    moveRightCircleBackToOrigin = () => {
        this.setState({
            contactUsHidden: false,
            rightCircleHideDirection: ''
        })
    }

    moveBackToHome = () => {
        let animClass = '';
        switch (this.state.currentScreen) {
            case SCREEN_PORTFOLIO:
                animClass = 'slide-left';
                break;
            case SCREEN_SERVICES:
                animClass = 'slide-right';
                break;
            case SCREEN_TEAM:
                animClass = 'slide-up';
                break;
        }

        this.moveNoiseBackward();
        this.moveCirclesToOrigin();

        this.setState({
            animClassName: animClass,
        }, () => {
            this.setState({
                currentScreen: SCREEN_HOME,
                transitionClass: 'inner-container'
            })
        })

    }

    moveToPortfolio = () => {
        this.moveNoiseLeft();
        this.moveCirclesRight();

        this.setState({
            animClassName: 'slide-right',
        }, () => {
            this.setState({
                currentScreen: SCREEN_PORTFOLIO,
                transitionClass: 'inner-container'
            })
        })
    }

    moveToServices = () => {
        this.moveNoiseRight();
        this.moveCirclesLeft();

        this.setState({
            animClassName: 'slide-left',
        }, () => {
            this.setState({
                currentScreen: SCREEN_SERVICES,
                transitionClass: 'inner-container'
            })
        })
    }

    moveToTeam = () => {
        this.moveNoiseDownward();
        this.moveCirclesUp();

        this.setState({
            animClassName: 'slide-down',
        }, () => {
            this.setState({
                currentScreen: SCREEN_TEAM,
                transitionClass: 'inner-container'
            })
        })
    }

    toggleContactPage = () => {
        let visibility = !this.state.isContactPageVisible;

        this.setState({
            isContactPageVisible: visibility
        })
    }

    cleanClassNames = () => { // to remove '..-done' word from classes to prevent components from freezing
        this.setState({
            transitionClass: 'inner-container-reset'
        });
    }

    setLoaded = () => {
        this.setState({
            isLoaded: true
        })
    }

    state = {
        isMobile: false,
        isLoaded: false,
        currentScreen: SCREEN_HOME,
        animClassName: 'home',
        transitionClass: 'inner-container',
        isContactPageVisible: false,
        contactUsHidden: false,

        //animation states
        noiseX: new Animated.Value(0),
        noiseY: new Animated.Value(0),
        leftCircleFocus: false,
        rightCircleFocus: false,
        bottomCircleFocus: false,
        leftCircleHideDirection: '',
        rightCircleHideDirection: '',
        bottomCircleHideDirection: '',

        //for main screen
        companyName: '',
        sloganText: ''
    }

    render() {

        if (!this.state.isLoaded) {
            return (
                <div style={{ backgroundColor: 'black', width: '100%', height: '100%', position: 'absolute' }}>
                </div>
            );
        }

        let circles = null;
        if (!this.state.isMobile && this.state.isLoaded) { // show circles
            circles = <CSSTransition
                className='circles-container'
                in={true}
                appear={true}
                timeout={timeout}
                classNames='circles'>
                <div>
                    <LeftCircle isFocus={this.state.leftCircleFocus} hideDirection={this.state.leftCircleHideDirection} />
                    <RightCircle isFocus={this.state.rightCircleFocus} hideDirection={this.state.rightCircleHideDirection} />
                    <BottomCircle isFocus={this.state.bottomCircleFocus} hideDirection={this.state.bottomCircleHideDirection} />
                </div>
            </CSSTransition>;
        }

        let currentScreenComponent = null;

        // decide on current screen
        switch (this.state.currentScreen) {
            case SCREEN_HOME:
                currentScreenComponent = <MainScreen
                    rightAction={this.moveToPortfolio}
                    leftAction={this.moveToServices}
                    downAction={this.moveToTeam}
                    isMobile={this.state.isMobile}
                    companyName={this.state.companyName}
                    sloganText={this.state.sloganText}  />;
                break;
            case SCREEN_TEAM:
                currentScreenComponent = <Team isMobile={this.state.isMobile} upAction={this.moveBackToHome} />;
                break;
            case SCREEN_SERVICES:
                currentScreenComponent = <Services isMobile={this.state.isMobile} rightAction={this.moveBackToHome} />;
                break;
            case SCREEN_PORTFOLIO:
                currentScreenComponent = <Portfolio
                    isMobile={this.state.isMobile}
                    leftAction={this.moveBackToHome}
                    moveAction={this.moveRightCircleMoreToLeft}
                    moveBackAction={this.moveRightCircleBackToOrigin} />;
                break;
        }

        return (
            <div className="container">
                <CSSTransition
                    in={true}
                    appear={true}
                    timeout={timeout}
                    classNames='circles'>
                    <ContactUs hidden={this.state.contactUsHidden}
                        visible={this.state.isContactPageVisible}
                        clickAction={this.toggleContactPage}
                        isMobile={this.state.isMobile} />
                </CSSTransition>

                <CSSTransition
                    in={true}
                    appear={true}
                    timeout={timeout}
                    classNames='circles'>
                    <Animated.div className="noise" style={{ left: this.state.noiseX, bottom: this.state.noiseY }}>
                        <img src={noisewhite} />
                    </Animated.div>
                </CSSTransition>

                {circles}

                <TransitionGroup className="inner-container">
                    <CSSTransition
                        className={this.state.transitionClass}
                        key={this.state.currentScreen}
                        in={true}
                        appear={true}
                        timeout={timeout}
                        classNames={this.state.animClassName}
                        onExited={this.cleanClassNames}>
                        <div className="inner-container"
                            children={currentScreenComponent}>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </div>
        );
    }
}

export default MainWebsite;
